import { render } from "./wechatNotice.vue?vue&type=template&id=24474058&scoped=true"
import script from "./wechatNotice.vue?vue&type=script&lang=js"
export * from "./wechatNotice.vue?vue&type=script&lang=js"

import "./wechatNotice.vue?vue&type=style&index=0&id=24474058&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24474058"]])

export default __exports__